import React from 'react'
import { Box, Paper, useTheme } from '@mui/material'
import { Bounce } from 'react-awesome-reveal'
import {
    Code,
    Terminal,
    Build,
    Palette,
    Web,
    DeveloperMode,
} from '@mui/icons-material'

export const TechnicalAnimation: React.FC = () => {
    const theme = useTheme()
    const techIcons = [
        { icon: <Code />, color: theme.palette.primary.main },
        { icon: <Terminal />, color: theme.palette.secondary.main },
        { icon: <Build />, color: theme.palette.warning.main },
        { icon: <Palette />, color: theme.palette.error.main },
        { icon: <Web />, color: theme.palette.info.main },
        { icon: <DeveloperMode />, color: theme.palette.success.main },
    ]

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: '900px',
                height: { xs: '300px', md: '500px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
            }}
        >
            {/* Animated grid background */}
            <Box
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    backgroundImage: `
                        linear-gradient(${theme.palette.primary.light}15 1px, transparent 1px),
                        linear-gradient(90deg, ${theme.palette.primary.light}15 1px, transparent 1px)
                    `,
                    backgroundSize: '50px 50px',
                    animation: 'gridMove 10s linear infinite',
                    '@keyframes gridMove': {
                        '0%': { transform: 'translate(0, 0)' },
                        '100%': { transform: 'translate(50px, 50px)' },
                    },
                }}
            />
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: 'repeat(3, 1fr)',
                        md: 'repeat(3, 1fr)',
                    },
                    gap: 3,
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                {techIcons.map((item, index) => (
                    <Bounce key={index} delay={index * 100} triggerOnce>
                        <Paper
                            elevation={8}
                            sx={{
                                p: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'background.paper',
                                borderRadius: 3,
                                border: `2px solid ${item.color}40`,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.1)',
                                    borderColor: item.color,
                                    boxShadow: `0 8px 24px ${item.color}60`,
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    color: item.color,
                                    fontSize: { xs: 32, md: 48 },
                                }}
                            >
                                {item.icon}
                            </Box>
                        </Paper>
                    </Bounce>
                ))}
            </Box>
        </Box>
    )
}
